import React from 'react';
import './PartnershipAwards.css';

const PartnershipAwards = () => {
    return (
        <div className='partnership_awards'>
            <div className='container'>
                <div className="flex-container">
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-1.webp" alt="sponsor icon" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-2.webp" alt="sponsor icon" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-3.webp" alt="sponsor icon" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-4.webp" alt="sponsor icon" /></div>
                    <div className="flex-item"><img className="img-fluid" src="/images/icons/sponsor-logo-5.webp" alt="sponsor icon" /></div>
                </div>
            </div>
        </div>
    )
};

export default PartnershipAwards;